import React, { useEffect, useRef, useState } from "react";
import * as echarts from "echarts";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { Button, Card, Dropdown, Menu, Radio, Spin } from "antd";
import { useStoreUpdaterWithAPI } from "../../Hooks/UseStoreUpdaterWithApi";
import { getAdjustedDate } from "./CommonFunctions";
import { adjustTimeByFiveHoursThirtyMinutes } from "../../Utils/DateConverstion";
import { APIConstants } from "../../Common/APIConstants";
import { DownloadOutlined } from "@ant-design/icons";
import jsPDF from "jspdf";
const DashSankey = ({activeTab}) => {
  const chartRef = useRef(null);
  const chartInstanceRef = useRef(null);
  const { makeRequest } = useStoreUpdaterWithAPI();
  const [sankeyData, setSankeyData] = useState({ nodes: [], links: [] });
  const correctDate = new Date(getAdjustedDate());
  const[isLoading,setIsLoading]=useState(false)
  const defaultFromDate = dayjs()
    .subtract(1, "day")
    .hour(6)
    .minute(0)
    .second(0);
  const defaultToDate = dayjs().hour(6).minute(0).second(0);
  const [toDate, setToDate] = useState(defaultToDate);
  const [fromDate, setFromDate] = useState(defaultFromDate);
  const [inputType,setInputType]=useState(0)
  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;
  const color = useSelector((state) => state.ThemeChange);
  // console.log(color);
  const colors = ["#59c3c9", "#696969", "#C8ff08", "#005E60"];
  const [selectedOption, setSelectedOption] = useState("1");

const handleRadioChange = (e) => {
  const selectedValue = e.target.value;
  setSelectedOption(selectedValue);
  // console.log(selectedValue)
  if(selectedValue==1){
    setInputType(0)
  }else{
    setInputType(1)
  }

  if (selectedValue == 1) {
    setFromDate(dayjs().subtract(1, "day").hour(6).minute(0).second(0));
    setToDate(dayjs().hour(6).minute(0).second(0));

  } else if (selectedValue == 2) {
    setFromDate(dayjs().startOf("month").hour(6).minute(0).second(0));
    setToDate(dayjs().hour(6).minute(0).second(0));
  }
};
const downloadAsPNG = () => {
  if (!chartInstanceRef.current) return;

  const url = chartInstanceRef.current.getDataURL({
    type: "png",
    pixelRatio: 2,
    backgroundColor: isdarkMode ? "#1f2937" : "#ffffff",
  });

  const link = document.createElement("a");
  link.href = url;
  link.download = activeTab==="3"?"Sankey-Energy Consumption Statistics Chart.png":activeTab==="4"&&"Sankey-Gas Consumption Statistics Chart.png";
  link.click();
};
const downloadAsPDF = () => {
  if (!chartInstanceRef.current) return;

  const img = chartInstanceRef.current.getDataURL({
    type: "png",
    pixelRatio: 2,
    backgroundColor: "#ffffff",
  });

  const pdf = new jsPDF("landscape", "px", "a4");
  const w = pdf.internal.pageSize.getWidth();
  const h = pdf.internal.pageSize.getHeight();

  pdf.addImage(img, "PNG", 20, 20, w - 40, h - 40);
  pdf.save(activeTab==="3"?"Sankey-Energy Consumption Statistics Chart.pdf":activeTab==="4"&&"Sankey-Gas Consumption Statistics Chart.pdf");
};

  useEffect(() => {

    const colorList = ["#59c3c9", "#696969", "#C8ff08", "#005E60"]; // Ordered colors

    const fetchData = async () => {
      setIsLoading(true)
      const inputData = {
        FromDate: adjustTimeByFiveHoursThirtyMinutes(fromDate),
        ToDate: adjustTimeByFiveHoursThirtyMinutes(toDate),
      };
      console.log(inputType)

      const response = await makeRequest({
        type: APIConstants.GET,
        url: activeTab==="3"?`${APIConstants.DASHBOARD_SANKEY}/${inputData.FromDate}/${inputData.ToDate}/${inputType}`:`${APIConstants.DASHBOARD_SANKEY_GAS}/${inputData.FromDate}/${inputData.ToDate}/${inputType}`,
      });
      const nodesSet = new Set();
      const links = [];

      const targetColorMap = new Map();
      let colorIndex = 0;

      response?.forEach((item) => {
        const source = item.source || "Total";
        const target = item.target || "Total";
        const value = item.consumption;

        nodesSet.add(source);
        nodesSet.add(target);

        // Assign a color in order for each new target
        if (!targetColorMap.has(target)) {
          const color = colorList[colorIndex % colorList.length];
          targetColorMap.set(target, color);
          colorIndex++;
        }

        links.push({
          source,
          target,
          value,
          lineStyle: { color: targetColorMap.get(target) },
        });
      });

      const nodes = Array.from(nodesSet).map((name) => ({ name }));
      setSankeyData({ nodes, links });
      setIsLoading(false)
    };

    fetchData();
  }, [inputType]);

useEffect(() => {
    if (!chartRef.current) return;

  const chart = echarts.init(chartRef.current);
chartInstanceRef.current = chart;
    const labelColor = isdarkMode ? "#fff" : "#000";

    // Detect first level and root total
    const rootName = sankeyData.nodes?.[0]?.name;
    const rootTotal = sankeyData.links
      .filter((l) => l.source === rootName)
      .reduce((sum, l) => sum + (l.value || 0), 0);

    // Detect leaf nodes (no outgoing edges)
    const sourceNodes = new Set(sankeyData.links.map((l) => l.source));
    const leafNodes = sankeyData.nodes
      .filter((node) => !sourceNodes.has(node.name))
      .map((node) => node.name);

    const allValuesZero = sankeyData.links.every(
      (l) => (l.value ?? 0) === 0
    );

    if (allValuesZero) {
      chart.setOption({
        graphic: {
          elements: [
            {
              type: "text",
              left: "center",
              top: "middle",
              style: {
                text: "No data available",
                fontSize: 20,
                fill: isdarkMode ? "#aaa" : "#555",
              },
            },
          ],
        },
      });
    } else {
     chart.setOption({
  tooltip: { trigger: "item", triggerOn: "mousemove" },

  toolbox: {
    show: true,
    right: 20,
    feature: {
      saveAsImage: {
        show: true,
        title: "Download Image",
        type: "png",          // png | jpeg | svg
        name: "Sankey_Chart", // file name
        backgroundColor: isdarkMode ? "#000" : "#fff",
        pixelRatio: 2         // higher = better quality
      }
    }
  },

  animationDuration: 800,
  series: [
    {
      type: "sankey",
      data: sankeyData.nodes,
      links: sankeyData.links,
      layout: "none",
      emphasis: { focus: "adjacency" },
      lineStyle: { curveness: 0.5 },
      label: {
        color: labelColor,
        formatter: (params) => {
          const name = params.name;
          const value = params.value || 0;

          if (!rootTotal) return `${name} ${value}`;

          if (leafNodes.includes(name)) {
            const percent = Math.min(
              100,
              ((value / rootTotal) * 100)
            ).toFixed(1);

            return `${name} ${value} (${percent}%)`;
          }

          return `${name} ${value}`;
        },
      },
    },
  ],
});

    }

    const resizeObserver = new ResizeObserver(() => chart.resize());
    resizeObserver.observe(chartRef.current);

    return () => {
      resizeObserver.disconnect();
      chart.dispose();
    };
  }, [sankeyData, isdarkMode]);


  console.log(sankeyData);

  return (
        <Card
extra={
  <Dropdown
    trigger={["click"]}
    popupClassName={isdarkMode ? "dark-dropdown" : ""}
    overlay={
      <Menu
        style={{
          backgroundColor: isdarkMode ? "#1f2937" : "#ffffff",
          borderRadius: 8,
          border: isdarkMode ? "1px solid #374151" : "1px solid #e5e7eb",
        }}
        items={[
          {
            key: "png",
            label: (
              <span
                style={{
                  color: isdarkMode ? "#ffffff" : "#000000",
                }}
                onClick={downloadAsPNG}
              >
                Download PNG
              </span>
            ),
          },
          {
            key: "pdf",
            label: (
              <span
                style={{
                  color: isdarkMode ? "#ffffff" : "#000000",
                }}
                onClick={downloadAsPDF}
              >
                Download PDF
              </span>
            ),
          },
        ]}
      />
    }
  >
    <Button
      icon={<DownloadOutlined />}
      style={{
        backgroundColor: isdarkMode ? "#374151" : "#ffffff",
        color: isdarkMode ? "#ffffff" : "#000000",
        border: isdarkMode ? "1px solid #4b5563" : "1px solid #d9d9d9",
      }}
    >
      Download
    </Button>
  </Dropdown>
}

      title={
        <div className={`${isdarkMode?'text-white':'text-black'}`}>
        {activeTab==="3"?" Nemak Aluminium – Energy Consumption Statistics":"Nemak Aluminium – Gas Consumption Statistics"}
          {/* Energy Consumption Statistics */}
        </div>
      }
      hoverable
      className="shadow-md rounded-xl border max-h-[75vh]"
      style={{
        background: isdarkMode ? "#1f2937" : "#ffffff",
        color: isdarkMode ? "white" : "black",
      }}
    >
      <div style={{ textAlign: "center", marginBottom: "10px" }} >
        <Radio.Group  onChange={handleRadioChange} value={selectedOption}>
          <Radio className={`${isdarkMode?'text-white':'text-black'}`} value="1">Yesterday Consumption ({activeTab==="3"?"kWh":"Kg"})</Radio>
          <Radio  className={`${isdarkMode?'text-white':'text-black'}`} value="2">MTD Consumption ({activeTab==="3"?"kWh":"Kg"})</Radio>
        </Radio.Group>
      </div>
      
<div
  style={{
    position: "relative",
    width: "100%",
    height: "60vh",
    minHeight: "400px",
    maxHeight: "70vh"
  }}
>
  {isLoading && (
    <div
      style={{
        position: "absolute",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(255,255,255,0.6)",
        zIndex: 10
      }}
    >
      <Spin size="large" />
    </div>
  )}

  <div
    ref={chartRef}
    style={{
      width: "100%",
      height: "100%",
      overflow: "hidden"
    }}
  />
</div>
      {/* <div 
       ref={chartRef} 
       style={{
    width: "100%",
    height: "60vh",
    minHeight: "400px",
    maxHeight: "70vh",
    overflow: "hidden"
  }}></div> */}
    </Card>

  );
};

// const DashSankey = () => {
//   const chartRef = useRef(null);
//   const mode = useSelector((state) => state.darkMode);

//   const { isdarkMode } = mode;
//   const [selectedOption, setSelectedOption] = useState("yesterday");

//   const handleRadioChange = (e) => {
//     console.log("Selected:", e.target.value);
//     setSelectedOption(e.target.value);
//   };

// const staticSankeyData = {
//   nodes: [
//     // Level 1
//     { name: "Main Inlet" },

//     // Level 2
//     { name: "RO Water" },
//     { name: "Raw Water" },

//     // Level 3
//     { name: "RO - IN" },
//     { name: "RO - OUT" },
//     { name: "Heat Treatment - 1" },
//     { name: "Heat Treatment - 2" },
//     { name: "Sand Plant" },
//     { name: "Canteen" },
//     { name: "Toilet" },
//     { name: "Gardening" },
//     { name: "Fire Pump" },

//     // Level 4 (Shifts)
//     { name: "Shift 1" },
//     { name: "Shift 2" },
//     { name: "Shift 3" },
//   ],

//   links: [
//     // Level 1 → Level 2
//     { source: "Main Inlet", target: "RO Water", value: 1800 },
//     { source: "Main Inlet", target: "Raw Water", value: 2700 },

//     // Level 2 → Level 3
//     { source: "RO Water", target: "RO - IN", value: 900 },
//     { source: "RO Water", target: "RO - OUT", value: 900 },

//     { source: "Raw Water", target: "Heat Treatment - 1", value: 400 },
//     { source: "Raw Water", target: "Heat Treatment - 2", value: 400 },
//     { source: "Raw Water", target: "Sand Plant", value: 400 },
//     { source: "Raw Water", target: "Canteen", value: 300 },
//     { source: "Raw Water", target: "Toilet", value: 300 },
//     { source: "Raw Water", target: "Gardening", value: 300 },
//     { source: "Raw Water", target: "Fire Pump", value: 300 },

//     // Level 3 → Level 4 (ALL → ALL)
//     // Each Level-3 value divided equally into 3 shifts

//     // RO - IN
//     { source: "RO - IN", target: "Shift 1", value: 300 },
//     { source: "RO - IN", target: "Shift 2", value: 300 },
//     { source: "RO - IN", target: "Shift 3", value: 300 },

//     // RO - OUT
//     { source: "RO - OUT", target: "Shift 1", value: 300 },
//     { source: "RO - OUT", target: "Shift 2", value: 300 },
//     { source: "RO - OUT", target: "Shift 3", value: 300 },

//     // Heat Treatment - 1
//     { source: "Heat Treatment - 1", target: "Shift 1", value: 133.33 },
//     { source: "Heat Treatment - 1", target: "Shift 2", value: 133.33 },
//     { source: "Heat Treatment - 1", target: "Shift 3", value: 133.34 },

//     // Heat Treatment - 2
//     { source: "Heat Treatment - 2", target: "Shift 1", value: 133.33 },
//     { source: "Heat Treatment - 2", target: "Shift 2", value: 133.33 },
//     { source: "Heat Treatment - 2", target: "Shift 3", value: 133.34 },

//     // Sand Plant
//     { source: "Sand Plant", target: "Shift 1", value: 133.33 },
//     { source: "Sand Plant", target: "Shift 2", value: 133.33 },
//     { source: "Sand Plant", target: "Shift 3", value: 133.34 },

//     // Canteen
//     { source: "Canteen", target: "Shift 1", value: 100 },
//     { source: "Canteen", target: "Shift 2", value: 100 },
//     { source: "Canteen", target: "Shift 3", value: 100 },

//     // Toilet
//     { source: "Toilet", target: "Shift 1", value: 100 },
//     { source: "Toilet", target: "Shift 2", value: 100 },
//     { source: "Toilet", target: "Shift 3", value: 100 },

//     // Gardening
//     { source: "Gardening", target: "Shift 1", value: 100 },
//     { source: "Gardening", target: "Shift 2", value: 100 },
//     { source: "Gardening", target: "Shift 3", value: 100 },

//     // Fire Pump
//     { source: "Fire Pump", target: "Shift 1", value: 100 },
//     { source: "Fire Pump", target: "Shift 2", value: 100 },
//     { source: "Fire Pump", target: "Shift 3", value: 100 },
//   ],
// };



// const round2 = (num) => Math.round(num * 100) / 100;

// const calculateNodeTotals = () => {
//   const totals = {};

//   // Initialize all nodes
//   staticSankeyData.nodes.forEach((node) => {
//     totals[node.name] = 0;
//   });

//   // Calculate totals from links
//   staticSankeyData.links.forEach(({ source, target, value }) => {
//     // Incoming flow
//     totals[target] = round2(totals[target] + value);

//     // Track outgoing only for Main Inlet
//     if (source === "Main Inlet") {
//       totals[source] = round2(totals[source] + value);
//     }
//   });

//   return totals;
// };


// const nodeTotals = calculateNodeTotals();

// const sankeyNodesWithValues = staticSankeyData.nodes.map((node) => ({
//   ...node,
//   value: nodeTotals[node.name] || 0,
// }));


// useEffect(() => {
//   if (!chartRef.current) return;

//   const chart = echarts.init(chartRef.current);
//   const textColor = isdarkMode ? "#ffffff" : "#000000";

//   chart.setOption({
//     title: {
//       text: "Water Consumption",
//       left: "center",
//       textStyle: {
//         color: textColor,
//         fontWeight: "bold",
//       },
//     },

//     tooltip: {
//       trigger: "item",
//       formatter: (item) => {
//         if (item.data.source) {
//           return `
//             ${item.data.source} → ${item.data.target}
//             <br/><b>${item.value} kL</b>
//           `;
//         }
//         return `
//           ${item.name}
//           <br/><b>Total: ${nodeTotals[item.name] || 0} kL</b>
//         `;
//       },
//     },

// series: [
//   {
//     type: "sankey",
//     data: sankeyNodesWithValues,
//     links: staticSankeyData.links,
//     nodeWidth: 20,
//     nodeGap: 14,
//     emphasis: { focus: "adjacency" },
//     lineStyle: {
//       color: "gradient",
//       curveness: 0.5,
//     },
//     label: {
//       color: isdarkMode ? "#fff" : "#000",
//       fontSize: 12,
//       formatter: (params) => {
//         return `${params.name}\n${params.value} kL`;
//       },
//     },
//   },
// ]


//   });

//   const resizeObserver = new ResizeObserver(() => chart.resize());
//   resizeObserver.observe(chartRef.current);

//   return () => {
//     resizeObserver.disconnect();
//     chart.dispose();
//   };
// }, [isdarkMode]);


//   return (
//     <Card
//       title="Sankey Flow Visualization"
//       className="shadow-md rounded-xl border"
//       style={{
//         background: isdarkMode ? "#1f2937" : "#ffffff",
//         color: isdarkMode ? "white" : "black",
//       }}
//     >
//       <div style={{ textAlign: "center", marginBottom: "10px" }}>
//         <Radio.Group onChange={handleRadioChange} value={selectedOption}>
//           <Radio value="yesterday">Yesterday Consumption (kWh)</Radio>
//           <Radio value="mtd">MTD Consumption (kWh)</Radio>
//         </Radio.Group>
//       </div>
//       <div ref={chartRef} style={{ width: "100%", height: "500px" }}></div>
//     </Card>
//   );
// };

export default DashSankey;
